<template>
  <div class="ErrorList">
    <el-dialog
        :title="$t('cnumber.cnumber19')"
        :visible="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
        width="460px"
        center
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-suffix=":"
          label-width="auto"
          class="demo-ruleForm"
        >
          <el-form-item :label="$t('cnumber.cnumber20')" prop="clientManagerUserId">
            <ChildCode
                v-model="ruleForm.clientManagerUserId"
                :newStr="setStr()"
            >
            </ChildCode>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="" style="display: flex;justify-content: flex-end;">
        <el-button class="form-btn btn-blue" @click="submitForm('ruleForm')">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ChildCode from "@/components/ChildCode/index.vue";

export default {
  name: "Fenpei",
  components: {ChildCode},
  props: {
    row: {
      type: Object || Array,
      default: () => ({})
    }
  },
  data(){
    return {
      ruleForm: {
        clientManagerUserId: undefined,
      },
      rules: {
        clientManagerUserId: [{ required: true, message: this.$t('common.pleaseInput') + this.$t('cnumber.cnumber3'), trigger: 'blur' }],
      },
    }
  },
  mounted() {
    // console.log(this.row.id,789);
    // this.ruleForm = this.row
  },
  methods: {
    setStr(){
      if(Array.isArray(this.row)){
        if (this.row[0]?.clientManagerUserName) {
          return this.row[0]?.clientManagerUserName
        }else if (this.row[0]?.userName) {
          return this.row[0]?.userName
        }else {
          return ''
        }
      }
      if (this.row?.clientManagerUserName) {
        return this.row?.clientManagerUserName
      }else if (this.row?.userName) {
        return this.row?.userName
      }else {
        return ''
      }
      /*if (this.row?.clientManagerUserName) {
        return this.row?.clientManagerUserName
      }else if (this.row[0]?.clientManagerUserName) {
        return this.row[0]?.clientManagerUserName
      }else {
        return ''
      }*/
      // return this.row.clientManagerUserName ? this.row.clientManagerUserName : this.row[0].clientManagerUserName
    },
    submitForm(formName) {
      // console.log(this.ruleForm ,123)
      let params = {
        ...this.ruleForm,
      }
      if(this.row.id || this.row.id === 0){
        params.orderIdList = [this.row.id]
      }else {
        params.orderIdList = this.row.map(item => item.id)
      }
      // console.log(params,999)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post("order/clientManagerUserUpdate",params).then(res => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: res.data.message,
              });
              // 父组件更新使用
              this.$options.confirm(true)
            }else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose () {
      this.$options.cancel('cancel')
    }
  }
}
</script>

<style scoped lang="less">
.ErrorList{
  :deep(.el-dialog__body){
    padding: 0 20px;
  }
  :deep(.el-dialog__footer){
    padding: 0 20px 20px;
  }
  .el-input-number {
    width: 100%;
    :deep(.el-input__inner){
      text-align: left;
    }
  }
}

</style>
